import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SalonDepositSalesMenuItem(props) {
  const { salonId } = props;

  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.deposit.sales(salonId));
  };

  return (
    <MainMenuItem
      itemTitleString="売上を確認する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SalonDepositSalesMenuItem;
